// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e632e6d","484":"00f847c1"}[chunkId] + ".chunk.js";
};